let routes = [

    // 煤炭
    {
        path: 'powerCoal',
        name: '动力煤炭',
        component: () => import('@/views/powerCoal/index'),
    },
    {
        path: 'powerCoal/twoPage/enterprise',
        name: '动力煤重点企业资讯二级页',
        component: () => import('@/views/powerCoal/twoPage/enterprise')
    },
    {
        path: 'powerCoal/enterprise',
        name: '动力煤重点企业资讯详情页',
        component: () => import('@/views/powerCoal/detail/enterprise')
    },
    {
        path: 'powerCoal/twoPage/industry',
        name: '动力煤行业动态二级页',
        component: () => import('@/views/powerCoal/twoPage/industry')
    }, {
        path: 'powerCoal/twoPage/standard',
        name: '动力煤技术及标准',
        component: () => import('@/views/powerCoal/twoPage/standard')
    }, {
        path: 'powerCoal/industry',
        name: '动力煤行业动态详情页',
        component: () => import('@/views/powerCoal/detail/industry')
    }, {
        path: 'powerCoal/twoPage/price',
        name: '动力煤价格指数二级页',
        component: () => import('@/views/powerCoal/twoPage/price')
    }, {
        path: 'powerCoal/priceIndex',
        name: '动力煤价格指数详情页',
        component: () => import('@/views/powerCoal/detail/priceIndex.vue')
    }, {
        path: 'powerCoal/twoPage/stock',
        name: '动力煤库存二级页',
        component: () => import('@/views/powerCoal/twoPage/stock')
    }, {
        path: 'powerCoal/stock',
        name: '动力煤库存详情页',
        component: () => import('@/views/powerCoal/detail/stock.vue')
    }, {
        path: 'powerCoal/twoPage/yield',
        name: '动力煤产量二级页',
        component: () => import('@/views/powerCoal/twoPage/yield')
        }, {
        path: 'powerCoal/yield',
        name: '动力煤产量详情页',
        component: () => import('@/views/powerCoal/detail/yield.vue')
        }, {
        path: 'powerCoal/twoPage/electric',
        name: '动力煤电厂二级页',
        component: () => import('@/views/powerCoal/twoPage/electric')
        }, {
        path: 'powerCoal/electric',
        name: '动力煤电厂详情页',
        component: () => import('@/views/powerCoal/detail/electric.vue')
        }, {
        path: 'powerCoal/twoPage/report',
        name: '动力煤研究报告二级页',
        component: () => import('@/views/powerCoal/twoPage/report')
    }, {
        path: 'powerCoal/twoPage/rate',
        name: '动力煤开工率二级页',
        component: () => import('@/views/powerCoal/twoPage/rate')
    }, {
        path: 'powerCoal/operatingRate',
        name: '动力煤开工率详情页',
        component: () => import('@/views/powerCoal/detail/operatingRate.vue')
    }, {
        path: 'powerCoal/enterpriseCapacity',
        name: '动力煤企业产能详情页',
        component: () => import('@/views/powerCoal/detail/enterpriseCapacity.vue')
    }, {
        path: 'powerCoal/nationalOutput',
        name: '动力煤全国产量详情页',
        component: () => import('@/views/powerCoal/detail/nationalOutput.vue')
    }, {
        path: 'powerCoal/addCapacity',
        name: '动力煤新增淘汰产能详情页',
        component: () => import('@/views/powerCoal/detail/addCapacity.vue')
    }, {
        path: 'powerCoal/twoPage/standard',
        name: '焦煤技术及标准二级页',
        component: () => import('@/views/powerCoal/twoPage/standard')
    },
    {
        path: 'powerCoal/map',
        name: '动力煤地图',
        component: () => import('@/views/coal/detail/map.vue')
    },
]

export default routes;
